import { alertsSlice } from './alertsReducer';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getIsAlertsInitedSelector } from './alertsSelectors';
import { failurePut } from '../../app/failurePut';
import { deleteRequest, getRequest, postRequest, putRequest } from '../../app/request';
import {
    IAlert,
    ICreateAlertPayload,
    IDeleteAlertPayload,
    ITriggeredAlertPayload,
    IUpdateAlertPayload,
} from './alerts.t';
import { openNotificationAction } from '../Notifications/notificationsReducer';
import TriggeredAlertNotification from './components/TriggeredAlertNotification/TriggeredAlertNotification';
import { getIsLocationPlatformDesktopSelector } from '../Location/locationSelectors';

function* initAlertsSaga() {
    const isAlertsAlreadyInited = yield select(getIsAlertsInitedSelector);
    if (isAlertsAlreadyInited) {return}
    yield put(alertsSlice.actions.setIsAlertsInitedAction(true));

    yield put(alertsSlice.actions.loadAlertsListAction());
}

function* createAlertSaga({ payload }: { payload: ICreateAlertPayload }) {
    try {
        const data: IAlert = yield call(postRequest, '/user/alerts', payload);
        yield put(alertsSlice.actions.createAlertSuccess(data));
    } catch (e) {
        yield call(failurePut, e, alertsSlice.actions.createAlertFailure);
    }
}

function* loadAlertsListSaga() {
    try {
        const data = yield call(getRequest, '/user/alerts');
        yield put(alertsSlice.actions.loadAlertsListSuccess(data));
    } catch (e) {
        yield call(failurePut, e, alertsSlice.actions.loadAlertsListFailure);
    }
}

function* updateAlertSaga({ payload }: { payload: IUpdateAlertPayload }) {
    try {
        const data: IAlert = yield call(putRequest, `/user/alerts/${payload.id}`, payload);
        yield put(alertsSlice.actions.updateAlertSuccess(data));
    } catch (e) {
        yield call(failurePut, e, alertsSlice.actions.updateAlertFailure);
    }
}

function* deleteAlertSaga({ payload }: { payload: IDeleteAlertPayload }) {
    try {
        yield call(deleteRequest, `/user/alerts/${payload}`);
        yield put(alertsSlice.actions.deleteAlertSuccess(payload));
    } catch (e) {
        yield call(failurePut, e, alertsSlice.actions.deleteAlertFailure);
    }
}

export function* handleTriggeredAlertSaga({ payload }: { payload: ITriggeredAlertPayload }) {
    const isDesktop = yield select(getIsLocationPlatformDesktopSelector);
    yield put(openNotificationAction({
        content: <TriggeredAlertNotification alert={payload} />,
        options: {
            autoClose: 6000,
            closeButton: false,
            position: isDesktop ? 'top-right' : undefined,
        },
    }));
}

export function* alertsSagas() {
    yield takeEvery(alertsSlice.actions.initAlertsAction, initAlertsSaga);
    yield takeEvery(alertsSlice.actions.createAlertAction, createAlertSaga);
    yield takeEvery(alertsSlice.actions.loadAlertsListAction, loadAlertsListSaga);
    yield takeEvery(alertsSlice.actions.updateAlertAction, updateAlertSaga);
    yield takeEvery(alertsSlice.actions.deleteAlertAction, deleteAlertSaga);
    yield takeEvery(alertsSlice.actions.handleTriggeredAlertAction, handleTriggeredAlertSaga);
}
